export const theme = {
    palette: {
        primary: {
            main: '#007aff',
        },
        secondary: {
            main: '#fa3f33',
        },
        incomplete: {
            main: '#ffe4e6',
            text: '#fe3f35',
        },
        background: {
            default: '#f4f6f8',
        },
        success: {
            main: '#007aff',
            light: '#00cda6',
        },
    },
    shape: {
        borderRadius: 12,
    },
    chip: {
        borderRadius: 0,
    },

    components: {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: '#999999',
                },
            },
        },
    },
};
export default theme;
